import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import OutputScoreText from "./components/OutputScoreText";
import { OUTPUT_FINAL_ID, persistedInsightsDataSelector, workspaceInsightsSelector, } from "store/rs-workspace/selectors/rs-workspace.selectors";
const OutputDescription = ({ objective: { insightId, insightInputSetId, outputId } }) => {
    const workspaceInsights = useSelector(workspaceInsightsSelector);
    const persistedInsightsData = useSelector(persistedInsightsDataSelector);
    const currentInsight = useMemo(() => workspaceInsights.find(({ id }) => id === insightId), [insightId, workspaceInsights]);
    const currentInsightPersistedData = useMemo(() => persistedInsightsData.find((data) => data.insightId === insightId), [insightId, persistedInsightsData]);
    const selectedInputSetInputs = useMemo(() => {
        const targetInsight = workspaceInsights?.find(({ id }) => id === insightId);
        const targetInputSet = targetInsight?.state?.input?.inputSets?.find(({ id }) => id === insightInputSetId);
        return targetInputSet?.inputs;
    }, [insightId, insightInputSetId, workspaceInsights]);
    const output = useMemo(() => currentInsight?.state.outputs.find(({ id }) => id === outputId), [currentInsight?.state.outputs, outputId]);
    const getOutputScore = useCallback((output) => currentInsightPersistedData?.scores?.find(({ outputId, inputSetId }) => inputSetId === insightInputSetId && output?.id === outputId), [currentInsightPersistedData?.scores, insightInputSetId]);
    if ([insightId, insightInputSetId, outputId, currentInsight, currentInsightPersistedData].some((item) => item === undefined)) {
        return null;
    }
    if (outputId === OUTPUT_FINAL_ID) {
        return (React.createElement(React.Fragment, null, (currentInsight?.state.outputs || []).map((output, index) => (React.createElement(OutputScoreText, { key: index, output: output, inputSetInputs: selectedInputSetInputs, index: index, outputScore: getOutputScore(output)?.score })))));
    }
    else {
        return (React.createElement(OutputScoreText, { output: output, inputSetInputs: selectedInputSetInputs, outputScore: getOutputScore(output)?.score }));
    }
};
export default OutputDescription;
